
import React from "react";
import { useRef } from "react";
import { useEffect } from "react";

const TrustWidgetSmall = ({ text }) => {
    const trustpilotRef = useRef(null);

    useEffect(() => {
        // Load Trustpilot script dynamically
        const protocol = window.location.protocol === 'https:' ? 'https:' : 'http:';
        const scriptId = 'trustpilot-widget-script';
        
        if (!document.getElementById(scriptId)) {
            const script = document.createElement('script');
            script.id = scriptId;
            script.type = 'text/javascript';
            script.src = `${protocol}//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js`;
            script.async = true;
            document.head.appendChild(script);
            
            script.onload = () => {
                if (window.Trustpilot && trustpilotRef.current) {
                    window.Trustpilot.loadFromElement(trustpilotRef.current, true);
                }
            };
        } else if (window.Trustpilot && trustpilotRef.current) {
            window.Trustpilot.loadFromElement(trustpilotRef.current, true);
        }
    }, []);


    return (

        <div className="rowMobile fitWidth cenSelf  ">
            <div ref={trustpilotRef}
                style={{ width: "230px" }}
                class="trustpilot-widget" data-locale="en-US" data-template-id="5419b637fa0340045cd0c936" data-businessunit-id="55c4a9180000ff000581e1e8" data-style-height="20px" data-style-width="100%" data-token="c212d485-7513-46f7-b5bb-f8a5c06f89e8">
                <a href="https://www.trustpilot.com/review/housesitmatch.com" target="_blank" rel="noopener">Trustpilot</a>
            </div>
            <span className style={{ fontSize: "14px", color: "black", fontWeight: "400" }}>
                {text}
            </span>
        </div>


    );
};

export default TrustWidgetSmall;
